import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { McpAdoptionPage } from '@/pages/super-admin/mcp-adoption/McpAdoptionPage';

const mcpAdoptionSearchSchema = z.object({
	tab: z.enum(['overview', 'companies']).default('overview'),
	period: z.enum(['7d', '30d', '90d']).default('30d'),
	page: z.coerce.number().default(1),
	limit: z.coerce.number().default(20),
	search: z.string().optional(),
	sort: z.enum(['calls', 'lastSeenAt', 'connectedUsers', 'name']).default('calls'),
});

export const Route = createFileRoute('/_authenticated/super-admin/mcp-adoption')({
	component: McpAdoptionPage,
	validateSearch: mcpAdoptionSearchSchema,
});
